<ami-dialog-message [setting]="message"></ami-dialog-message>
<pg-therapist-group-create
  *ngIf="open.create"
  (close)="onCloseCreate()"
></pg-therapist-group-create>

<pg-therapist-group-update
  *ngIf="open.update"
  (close)="onCloseUpdate()"
  [row]="itemToUpdate"
></pg-therapist-group-update>

<ami-table
  [settings]="table.settings"
  [data]="table.data"
  (action)="onReciveAction($event)"
></ami-table>
